import React, { useEffect, useRef, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import {
  RelativeWrap,
  SearchFieldContainer,
  SearchInput,
  SearchTypeMenu,
  SearchTypeOption,
  SearchTypePill
} from '../styles';
import { SearchFilterField } from '../types';

export type SearchFieldProps = {
  field: SearchFilterField;
  typeValue: string;
  argumentValue: string;
  onTypeChange: (value: string) => void;
  onArgumentChange: (value: string) => void;
  onSearch: () => void;
  disabled?: boolean;
};

const SearchField: React.FC<SearchFieldProps> = ({
  field,
  typeValue,
  argumentValue,
  onTypeChange,
  onArgumentChange,
  onSearch,
  disabled
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  const selectedType =
    field.types.find(type => type.value === typeValue) || field.types[0];

  useEffect(() => {
    if (!menuOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  return (
    <RelativeWrap ref={wrapRef}>
      <SearchFieldContainer>
        <SearchTypePill
          type="button"
          disabled={disabled}
          aria-haspopup="listbox"
          aria-expanded={menuOpen}
          onClick={() => !disabled && setMenuOpen(prev => !prev)}
        >
          {selectedType?.label || 'Tipo'}
          <Icon name="chevron down" size="small" />
        </SearchTypePill>

        <SearchInput
          type="text"
          value={argumentValue || ''}
          placeholder={field.placeholder || 'Digite...'}
          disabled={disabled || !typeValue}
          onChange={e => onArgumentChange(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onSearch();
            }
          }}
        />
      </SearchFieldContainer>

      {menuOpen && (
        <SearchTypeMenu role="listbox">
          {field.types.map(type => (
            <SearchTypeOption
              key={type.value}
              type="button"
              role="option"
              selected={type.value === typeValue}
              onClick={() => {
                onTypeChange(type.value);
                setMenuOpen(false);
              }}
            >
              {type.label}
            </SearchTypeOption>
          ))}
        </SearchTypeMenu>
      )}
    </RelativeWrap>
  );
};

export default SearchField;
